import ContentAPI from "@shared/_api/cms/content";

export default class Messages {
    static getMessages() {

        const locales = require.context('./../_locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
        const messages = {}
        locales.keys().forEach(key => {
            const matched = key.match(/([A-Za-z0-9-_]+)\./i)
            if (matched && matched.length > 1) {
                const locale = matched[1]
                messages[locale] = locales(key)
            }
        });

        return ContentAPI.fetchListByName("translation").then(messagesFromCms => {
            for (let i = 0; i < messagesFromCms.length; i++) {
                messages['en'][messagesFromCms[i].identifier.value] = messagesFromCms[i].value.value;
            }
            return messages;
        }).catch(() => {
            return messages;
        })

    }
}